export default "__VITE_ASSET__CTI61cmt__"